import { createContext, useContext } from 'react';

// Part of ABACUS-420 implementation
export const JobApplicationPrioritizedContext = createContext<boolean | undefined>(undefined);

export const useIsPrioritizedJob = (): boolean => {
  return !!useContext(JobApplicationPrioritizedContext);
};
